import { useEffect } from 'react';
import { useLocation, Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import CookieConsent from "react-cookie-consent";
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import MainPage from './pages/MainPage';
import Devis from './pages/Devis';
import Contact from './pages/Contact';
import Isolation from './pages/articles/Isolation';
import Panne from './pages/articles/Panne';
import Footer from './components/Footer';
import Services from './pages/articles/Services';
import UnderRoofing from './pages/articles/UnderRoofing';
import Roofing from './pages/articles/Roofing';
import Gutter from './pages/articles/Gutter';
import Bugs from './pages/articles/Bugs';
import Maintenance from './pages/Maintenance'; // Pce62

import MentionsLegales from './pages/MentionsLegales';

function App() {
  const location = useLocation();

  useEffect(() => {
    require('preline/preline');
  }, []);

  useEffect(() => {
    // @ts-ignore
    HSStaticMethods.autoInit();
  }, [location.pathname]);

  const isMaintenanceMode = false; // P083e

  return (
    <ThemeProvider>
      <>
        <Navbar />
        <Routes>
        {isMaintenanceMode ? ( // P083e
          <Route path="*" element={<Maintenance />} /> // P083e
        ) : (
          <>
            <Route path="/" element={<MainPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/isolation" element={<Isolation />} />
            <Route path="/panne" element={<Panne />} />
            <Route path="/gutter" element={<Gutter />} />
            <Route path="/underroofing" element={<UnderRoofing />} />
            <Route path="/bugs" element={<Bugs />} />
            <Route path="/roofing" element={<Roofing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/services" element={<Services />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/hero" element={<Hero />} />
            <Route path="/navbar" element={<Navbar />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
          </>
        )}
      </Routes>
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="J'accepte"
        declineButtonText="Je refuse"
        enableDeclineButton={true}
        cookieName="gdprConsent2AH"
        expires={150}
        style={{ background: "#2B373B", fontSize: "14px" }}
        buttonStyle={{ color: "#FFFFFF", background: "#007BFF", fontSize: "14px", borderRadius: "5px", padding: "10px 15px" }}
        declineButtonStyle={{ color: "#000000", background: "#F0F0F0", fontSize: "14px", borderRadius: "5px", padding: "10px 15px" }}
      >
        Ce site utilise des cookies pour améliorer l'expérience utilisateur. Consultez notre <Link to='/mentions-legales' style={{ color: "#ADD8E6", textDecoration: "underline" }}>politique de confidentialité</Link> pour plus d'informations.
      </CookieConsent>
      </>
    </ThemeProvider>
  );
}

export default App;
